<svg version="1.1" xmlns="http://www.w3.org/2000/svg" [attr.width]="width" [attr.height]="height"
     viewBox="-208 1022.5 2368 1332">
  <defs>
    <style
      type="text/css">@import url('https://fonts.googleapis.com/css?family=Open+Sans:400,700|Inconsolata:400');</style>
  </defs>
  <g id="stopWatch">
    <svg x="1960" y="1989" overflow="visible">
      <g transform="scale(1.0)">
        <svg x="-200" y="-200" width="400" height="400">
          <svg id="stopwatch"
               [attr.opacity]="stopwatch.opacity" xmlns="http://www.w3.org/2000/svg" width="400.0" height="400.0"
               viewBox="0 0
    400.0 400.0">
            <g id="ticks" stroke="lightgray" stroke-width="20">
              <line id="tick_0"
                    [attr.stroke]="tickColors[0]" [attr.opacity]="tickOpacity[0]" x1="200" y1="45" x2="200" y2="10"/>
              <line id="tick_1"
                    [attr.stroke]="tickColors[1]" [attr.opacity]="tickOpacity[1]" x1="250.32841772672595"
                    y1="53.39832753640164"
                    x2="261.69289914888986" y2="20.29472407687942"/>
              <line id="tick_2"
                    [attr.stroke]="tickColors[2]" [attr.opacity]="tickOpacity[2]" x1="295.2029704668985"
                    y1="77.683221043559"
                    x2="316.7004154110369" y2="50.06330321468522"/>
              <line id="tick_3"
                    [attr.stroke]="tickColors[3]" [attr.opacity]="tickOpacity[3]" x1="329.7608041306919"
                    y1="115.22303549102382"
                    x2="359.06163086988045" y2="96.07984995673888"/>
              <line id="tick_4"
                    [attr.stroke]="tickColors[4]" [attr.opacity]="tickOpacity[4]" x1="350.2570412205962"
                    y1="161.9497494931761"
                    x2="384.1860505284728" y2="153.35775744324815"/>
              <line id="tick_5"
                    [attr.stroke]="tickColors[5]" [attr.opacity]="tickOpacity[5]" x1="354.4705964160338"
                    y1="212.7997985482115"
                    x2="389.35105367126727" y2="215.69007563974313"/>
              <line id="tick_6"
                    [attr.stroke]="tickColors[6]" [attr.opacity]="tickOpacity[6]" x1="341.9448656315339"
                    y1="262.2627908212103"
                    x2="373.9969320644609" y2="276.3221306840642"/>
              <line id="tick_7"
                    [attr.stroke]="tickColors[7]" [attr.opacity]="tickOpacity[7]" x1="314.0372061543354"
                    y1="304.97864360198986"
                    x2="339.787543027895" y2="328.6834986088908"/>
              <line id="tick_8"
                    [attr.stroke]="tickColors[8]" [attr.opacity]="tickOpacity[8]" x1="273.77184592074644"
                    y1="336.31843143700576"
                    x2="290.43000467704405" y2="367.1000127292329"/>
              <line id="tick_9"
                    [attr.stroke]="tickColors[9]" [attr.opacity]="tickOpacity[9]" x1="225.51216149351382"
                    y1="352.88600202742197"
                    x2="231.2729721533395" y2="387.40864764651724"/>
              <line id="tick_10"
                    [attr.stroke]="tickColors[10]" [attr.opacity]="tickOpacity[10]" x1="174.4878385064863"
                    y1="352.88600202742197"
                    x2="168.7270278466606" y2="387.40864764651724"/>
              <line id="tick_11"
                    [attr.stroke]="tickColors[11]" [attr.opacity]="tickOpacity[11]" x1="126.22815407925367"
                    y1="336.31843143700587"
                    x2="109.5699953229561" y2="367.10001272923296"/>
              <line id="tick_12"
                    [attr.stroke]="tickColors[12]" [attr.opacity]="tickOpacity[12]" x1="85.96279384566463"
                    y1="304.9786436019899"
                    x2="60.21245697210503" y2="328.6834986088909"/>
              <line id="tick_13"
                    [attr.stroke]="tickColors[13]" [attr.opacity]="tickOpacity[13]" x1="58.05513436846613"
                    y1="262.26279082121033"
                    x2="26.00306793553912" y2="276.3221306840643"/>
              <line id="tick_14"
                    [attr.stroke]="tickColors[14]" [attr.opacity]="tickOpacity[14]" x1="45.52940358396617"
                    y1="212.79979854821156"
                    x2="10.648946328732734" y2="215.6900756397432"/>
              <line id="tick_15"
                    [attr.stroke]="tickColors[15]" [attr.opacity]="tickOpacity[15]" x1="49.74295877940378"
                    y1="161.9497494931761"
                    x2="15.813949471527224" y2="153.35775744324815"/>
              <line id="tick_16"
                    [attr.stroke]="tickColors[16]" [attr.opacity]="tickOpacity[16]" x1="70.23919586930805"
                    y1="115.22303549102388"
                    x2="40.938369130119526" y2="96.07984995673895"/>
              <line id="tick_17"
                    [attr.stroke]="tickColors[17]" [attr.opacity]="tickOpacity[17]" x1="104.79702953310135"
                    y1="77.6832210435591"
                    x2="83.29958458896294" y2="50.063303214685334"/>
              <line id="tick_18"
                    [attr.stroke]="tickColors[18]" [attr.opacity]="tickOpacity[18]" x1="149.67158227327403"
                    y1="53.39832753640164"
                    x2="138.3071008511101" y2="20.29472407687942"/>
            </g>
            <g id="leds">
              <svg x="50" y="95" width="300" height="200" viewBox="0 0 600 300">
                <svg x="0" y="0">
                  <g stroke="#c0c0c0" stroke-width="1">
                    <path id="segment_a1"
                          [attr.fill]="led[0].a"
                          d="M190.797 72.5L175.585 88h-59l-15.517-15.5L116.585 57h59l15.212 15.5z"/>
                    <path id="segment_b1"
                          [attr.fill]="led[0].b"
                          d="M194 75.385l15.5 15.212v45L194 151.115l-15.5-15.518v-45L194 75.385z"/>
                    <path id="segment_c1"
                          [attr.fill]="led[0].c"
                          d="M194 157.443l15.5 15.212v45L194 233.172l-15.5-15.517v-45l15.5-15.212z"/>
                    <path id="segment_d1"
                          [attr.fill]="led[0].d"
                          d="M190.797 236.057l-15.212 15.5h-59l-15.517-15.5 15.517-15.5h59l15.212 15.5z"/>
                    <path id="segment_e1"
                          [attr.fill]="led[0].e"
                          d="M98 157.443l15.5 15.212v45L98 233.172l-15.5-15.517v-45L98 157.443z"/>
                    <path id="segment_f1"
                          [attr.fill]="led[0].f" d="M98 75.385l15.5 15.212v45L98 151.115l-15.5-15.518v-45L98 75.385z"/>
                    <path id="segment_g1"
                          [attr.fill]="led[0].g"
                          d="M190.797 154l-15.212 15.5h-59L101.068 154l15.517-15.5h59l15.212 15.5z"/>
                    <path id="segment_p1"
                          [attr.fill]="led[0].p" d="M237.5 239.25a12.25 12.25 0 1 1-24.5 0 12.25 12.25 0 1 1 24.5 0z"/>
                  </g>
                </svg>
                <svg x="165" y="0">
                  <g stroke="#c0c0c0" stroke-width="1">
                    <path id="segment_a2"
                          [attr.fill]="led[1].a"
                          d="M190.797 72.5L175.585 88h-59l-15.517-15.5L116.585 57h59l15.212 15.5z"/>
                    <path id="segment_b2"
                          [attr.fill]="led[1].b"
                          d="M194 75.385l15.5 15.212v45L194 151.115l-15.5-15.518v-45L194 75.385z"/>
                    <path id="segment_c2"
                          [attr.fill]="led[1].c"
                          d="M194 157.443l15.5 15.212v45L194 233.172l-15.5-15.517v-45l15.5-15.212z"/>
                    <path id="segment_d2"
                          [attr.fill]="led[1].d"
                          d="M190.797 236.057l-15.212 15.5h-59l-15.517-15.5 15.517-15.5h59l15.212 15.5z"/>
                    <path id="segment_e2"
                          [attr.fill]="led[1].e"
                          d="M98 157.443l15.5 15.212v45L98 233.172l-15.5-15.517v-45L98 157.443z"/>
                    <path id="segment_f2"
                          [attr.fill]="led[1].f" d="M98 75.385l15.5 15.212v45L98 151.115l-15.5-15.518v-45L98 75.385z"/>
                    <path id="segment_g2"
                          [attr.fill]="led[1].g"
                          d="M190.797 154l-15.212 15.5h-59L101.068 154l15.517-15.5h59l15.212 15.5z"/>
                    <path id="segment_p2"
                          [attr.fill]="led[1].p" d="M237.5 239.25a12.25 12.25 0 1 1-24.5 0 12.25 12.25 0 1 1 24.5 0z"/>
                  </g>
                </svg>
                <svg x="330" y="0">
                  <g stroke="#c0c0c0" stroke-width="1">
                    <path id="segment_a3"
                          [attr.fill]="led[2].a"
                          d="M190.797 72.5L175.585 88h-59l-15.517-15.5L116.585 57h59l15.212 15.5z"/>
                    <path id="segment_b3"
                          [attr.fill]="led[2].b"
                          d="M194 75.385l15.5 15.212v45L194 151.115l-15.5-15.518v-45L194 75.385z"/>
                    <path id="segment_c3"
                          [attr.fill]="led[2].c"
                          d="M194 157.443l15.5 15.212v45L194 233.172l-15.5-15.517v-45l15.5-15.212z"/>
                    <path id="segment_d3"
                          [attr.fill]="led[2].d"
                          d="M190.797 236.057l-15.212 15.5h-59l-15.517-15.5 15.517-15.5h59l15.212 15.5z"/>
                    <path id="segment_e3"
                          [attr.fill]="led[2].e"
                          d="M98 157.443l15.5 15.212v45L98 233.172l-15.5-15.517v-45L98 157.443z"/>
                    <path id="segment_f3"
                          [attr.fill]="led[2].f" d="M98 75.385l15.5 15.212v45L98 151.115l-15.5-15.518v-45L98 75.385z"/>
                    <path id="segment_g3"
                          [attr.fill]="led[2].g"
                          d="M190.797 154l-15.212 15.5h-59L101.068 154l15.517-15.5h59l15.212 15.5z"/>
                  </g>
                </svg>
              </svg>
            </g>
          </svg>
        </svg>
      </g>
    </svg>
  </g>
  <g id="background">
    <g opacity="0.2" id="processing-background">
      <polygon points="1408 1184, 1856 1443, 672 2128, 224 1869" fill="#e6e7e8" stroke-width="0"
               stroke="#818181"></polygon>
    </g>
    <g opacity="0.1" id="validate-background">
      <polygon points="1280 1110, 1392 1175, 208 1859, 96 1795" fill="#e6e7e8" stroke-width="0"
               stroke="#818181"></polygon>
    </g>
    <g opacity="0.1" id="cs-background">
      <polygon points="0 1850, 576 2183, 432 2266, -144 1933" fill="#e6e7e8" stroke-width="0"
               stroke="#818181"></polygon>
    </g>
  </g>
  <g id="lines">
    <g id="encapsulate-to-publish" [attr.opacity]="lines.encapsulateToPublish.colours.opacity">
      <line x1="1264" y1="1378" x2="1357" y2="1325" [attr.stroke]="lines.encapsulateToPublish.colours.line"
            stroke-width="10"
            stroke-linecap="round"></line>
      <polygon points="1376 1314, 1325 1324, 1351 1328, 1357 1343, 1376 1314" stroke-linejoin="round"
               [attr.fill]="lines.encapsulateToPublish.colours.line"
               [attr.stroke]="lines.encapsulateToPublish.colours.line" stroke-width="1"></polygon>
    </g>
    <g id="apigateway-to-ingest" [attr.opacity]="lines.apiToIngest.colours.opacity">
      <line x1="320" y1="1924" x2="397" y2="1880" [attr.stroke]="lines.apiToIngest.colours.line" stroke-width="10"
            stroke-linecap="round"></line>
      <polygon points="416 1869, 365 1879, 391 1883, 397 1898, 416 1869" stroke-linejoin="round"
               [attr.fill]="lines.apiToIngest.colours.line"
               [attr.stroke]="lines.apiToIngest.colours.line" stroke-width="1"></polygon>
    </g>
    <g id="apigateway-to-cs" [attr.opacity]="lines.apiToCreditSuisse.colours.opacity">
      <line x1="255" y1="1962" x2="211" y2="1987" [attr.stroke]="lines.apiToCreditSuisse.colours.line" stroke-width="10"
            stroke-linecap="round"></line>
      <polygon points="192 1998, 243 1987, 217 1984, 211 1968, 192 1998" stroke-linejoin="round"
               [attr.fill]="lines.apiToCreditSuisse.colours.line"
               [attr.stroke]="lines.apiToCreditSuisse.colours.line" stroke-width="1"></polygon>
    </g>
    <g id="encapsulate-to-validate" [attr.opacity]="lines.encapsulateToValidate.colours.opacity">
      <line x1="1168" y1="1378" x2="1107" y2="1343" [attr.stroke]="lines.encapsulateToValidate.colours.line"
            stroke-width="10"
            stroke-linecap="round"></line>
      <polygon points="1088 1332, 1107 1362, 1113 1346, 1139 1343, 1088 1332" stroke-linejoin="round"
               [attr.fill]="lines.encapsulateToValidate.colours.line"
               [attr.stroke]="lines.encapsulateToValidate.colours.line" stroke-width="1"></polygon>
    </g>
    <g id="regxchange-get-to-retrieve" [attr.opacity]="lines.regXchangeGetToRetrieve.colours.opacity">
      <line x1="1264" y1="1933" x2="1357" y2="1880" [attr.stroke]="lines.regXchangeGetToRetrieve.colours.line"
            stroke-width="10"
            stroke-linecap="round"></line>
      <polygon points="1376 1869, 1325 1879, 1351 1883, 1357 1898, 1376 1869" stroke-linejoin="round"
               [attr.fill]="lines.regXchangeGetToRetrieve.colours.line"
               [attr.stroke]="lines.regXchangeGetToRetrieve.colours.line" stroke-width="1"></polygon>
    </g>
    <g id="raise-jira-to-jira" [attr.opacity]="lines.jiraToRaiseJira.colours.opacity">
      <line x1="960" y1="2109" x2="883" y2="2153" [attr.stroke]="lines.jiraToRaiseJira.colours.line" stroke-width="10"
            stroke-linecap="round"></line>
      <polygon points="864 2165, 915 2154, 889 2150, 883 2135, 864 2165" stroke-linejoin="round"
               [attr.fill]="lines.jiraToRaiseJira.colours.line"
               [attr.stroke]="lines.jiraToRaiseJira.colours.line" stroke-width="1"></polygon>
    </g>
    <g id="enrich-to-combine" [attr.opacity]="lines.enrichToCombine.colours.opacity">
      <line x1="880" y1="1600" x2="973" y2="1547" [attr.stroke]="lines.enrichToCombine.colours.line" stroke-width="10"
            stroke-linecap="round"></line>
      <polygon points="992 1536, 941 1546, 967 1550, 973 1565, 992 1536" stroke-linejoin="round"
               [attr.fill]="lines.enrichToCombine.colours.line"
               [attr.stroke]="lines.enrichToCombine.colours.line" stroke-width="1"></polygon>
    </g>
    <g id="combine-to-encapsulate" [attr.opacity]="lines.combineToEncapsulate.colours.opacity">
      <line x1="1072" y1="1489" x2="1165" y2="1436" [attr.stroke]="lines.combineToEncapsulate.colours.line"
            stroke-width="10"
            stroke-linecap="round"></line>
      <polygon points="1184 1425, 1133 1435, 1159 1439, 1165 1454, 1184 1425" stroke-linejoin="round"
               [attr.fill]="lines.combineToEncapsulate.colours.line"
               [attr.stroke]="lines.combineToEncapsulate.colours.line" stroke-width="1"></polygon>
    </g>
    <g id="diff-check-to-diffs" [attr.opacity]="lines.diffToDiffReport.colours.opacity">
      <line x1="2048" y1="1480" x2="1971" y2="1524" [attr.stroke]="lines.diffToDiffReport.colours.line"
            stroke-width="10"
            stroke-linecap="round"></line>
      <polygon points="1952 1536, 2003 1525, 1977 1521, 1971 1506, 1952 1536" stroke-linejoin="round"
               [attr.fill]="lines.diffToDiffReport.colours.line"
               [attr.stroke]="lines.diffToDiffReport.colours.line" stroke-width="1"></polygon>
    </g>
    <g id="transform-to-enrich" [attr.opacity]="lines.transformToEnrich.colours.opacity">
      <line x1="688" y1="1711" x2="781" y2="1658" [attr.stroke]="lines.transformToEnrich.colours.line" stroke-width="10"
            stroke-linecap="round"></line>
      <polygon points="800 1647, 749 1657, 775 1661, 781 1676, 800 1647" stroke-linejoin="round"
               [attr.fill]="lines.transformToEnrich.colours.line"
               [attr.stroke]="lines.transformToEnrich.colours.line" stroke-width="1"></polygon>
    </g>
    <g id="ingest-to-transform" [attr.opacity]="lines.ingestToTransform.colours.opacity">
      <line x1="496" y1="1822" x2="589" y2="1769" [attr.stroke]="lines.ingestToTransform.colours.line" stroke-width="10"
            stroke-linecap="round"></line>
      <polygon points="608 1758, 557 1768, 583 1772, 589 1787, 608 1758" stroke-linejoin="round"
               [attr.fill]="lines.ingestToTransform.colours.line"
               [attr.stroke]="lines.ingestToTransform.colours.line" stroke-width="1"></polygon>
    </g>
    <g id="retrieve-to-combine" [attr.opacity]="lines.retrieveToCombine.colours.opacity">
      <line x1="1360" y1="1822" x2="1040" y2="1637" [attr.stroke]="lines.retrieveToCombine.colours.line"
            stroke-width="10"
            stroke-linecap="round"></line>
      <line x1="1040" y1="1637" x2="1054" y2="1551" [attr.stroke]="lines.retrieveToCombine.colours.line"
            stroke-width="10"
            stroke-linecap="round"></line>
      <polygon points="1056 1536, 1029 1563, 1053 1556, 1074 1565, 1056 1536" stroke-linejoin="round"
               [attr.fill]="lines.retrieveToCombine.colours.line"
               [attr.stroke]="lines.retrieveToCombine.colours.line" stroke-width="1"></polygon>
    </g>
    <g id="ingest-to-validate" [attr.opacity]="lines.ingestToValidate.colours.opacity">
      <line x1="400" y1="1822" x2="339" y2="1787" [attr.stroke]="lines.ingestToValidate.colours.line" stroke-width="10"
            stroke-linecap="round"></line>
      <polygon points="320 1776, 339 1806, 345 1790, 371 1787, 320 1776" stroke-linejoin="round"
               [attr.fill]="lines.ingestToValidate.colours.line"
               [attr.stroke]="lines.ingestToValidate.colours.line" stroke-width="1"></polygon>
    </g>
    <g id="regxchange-publish-to-diff-checker" [attr.opacity]="lines.regXchangeToDiff.colours.opacity">
      <line x1="1648" y1="1212" x2="2013" y2="1423" [attr.stroke]="lines.regXchangeToDiff.colours.line"
            stroke-width="10"
            stroke-linecap="round"></line>
      <polygon points="2032 1434, 2013 1404, 2007 1419, 1981 1423, 2032 1434" stroke-linejoin="round"
               [attr.fill]="lines.regXchangeToDiff.colours.line"
               [attr.stroke]="lines.regXchangeToDiff.colours.line" stroke-width="1"></polygon>
    </g>
    <g id="publish-to-regxchange-publish" [attr.opacity]="lines.publishToRegXchange.colours.opacity">
      <line x1="1456" y1="1267" x2="1533" y2="1223" [attr.stroke]="lines.publishToRegXchange.colours.line"
            stroke-width="10"
            stroke-linecap="round"></line>
      <polygon points="1552 1212, 1501 1222, 1527 1226, 1533 1241, 1552 1212" stroke-linejoin="round"
               [attr.fill]="lines.publishToRegXchange.colours.line"
               [attr.stroke]="lines.publishToRegXchange.colours.line" stroke-width="1"></polygon>
    </g>
  </g>
  <g id="lambdas">
    <g id="ingest"
       [attr.opacity]="lambdas.ingest.colours.opacity">
      <svg x="400" y="1764" height="113.438" width="96" viewBox="0 0 25.4 30.014">
        <g transform="translate(412.599 -86.957)">
          <path d="M-395.754 111.92l8.29-4.786v4.785l-8.29 4.786z"
                [attr.fill]="lambdas.ingest.colours.side" fill-rule="evenodd">
          </path>
          <path d="M-404.044 111.92h8.29v4.785h-8.29z"
                [attr.fill]="lambdas.ingest.colours.front" fill-rule="evenodd">
          </path>
          <path d="M-412.333 107.134v4.785l8.29 4.786v-4.786z"
                [attr.fill]="lambdas.ingest.colours.front" fill-rule="evenodd">
          </path>
          <path d="M-412.333 107.134l8.29 4.785h8.289l8.29-4.785M-404.044 111.92v4.785M-395.754 111.92v4.785"
                fill="none" [attr.stroke]="lambdas.ingest.colours.highlight" stroke-width=".26588"></path>
          <path
            d="M-412.333 102.348v9.571l8.29 4.786h8.289l8.29-4.786v-9.571l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".53176"></path>
          <path
            d="M-395.754 106.75l8.29-4.786v4.786l-8.29 4.786z" [attr.fill]="lambdas.ingest.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 106.75h8.29v4.786h-8.29z" [attr.fill]="lambdas.ingest.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.ingest.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964l8.29 4.786h8.289l8.29-4.786M-404.044 106.75v4.786M-395.754 106.75v4.786"
            fill="none" [attr.stroke]="lambdas.ingest.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 97.178v9.572l8.29 4.786h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".532"></path>
          <path
            d="M-412.333 92.01v4.785l8.29 4.786h8.289l8.29-4.786v-4.786l-8.29-4.786h-8.29z"
            [attr.fill]="lambdas.ingest.colours.main" fill-rule="evenodd"></path>
          <path
            d="M-395.754 101.58l8.29-4.785v4.786l-8.29 4.786z" [attr.fill]="lambdas.ingest.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 101.58h8.29v4.787h-8.29z" [attr.fill]="lambdas.ingest.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.ingest.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795l8.29 4.786h8.289l8.29-4.786M-404.044 101.58v4.787M-395.754 101.58v4.787"
            fill="none" [attr.stroke]="lambdas.ingest.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 92.01v9.57l8.29 4.787h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none" stroke="#000000"
            stroke-width=".532"></path>
          <circle cx="-136.478"
                  cy="325.284" [attr.fill]="lambdas.ingest.colours.background" r="5.801"
                  transform="scale(1.22475 .7071) rotate(45)"></circle>
          <g
            font-family="sans-serif" font-size="3.191" stroke-width=".266" style="line-height: 0%;">
            <path
              d="M-399.242 93.57l.48-.601q.222-.275.177-.448-.04-.17-.467-.416l-.507-.293 1.065-.614.937.541q.825.476.92.934.1.46-.417 1.114l-3.452 4.39-1.622-.937 1.654-2.121-3.729.923-1.622-.936z"
              [attr.fill]="lambdas.ingest.colours.text" font-family="Droid Serif" font-size="9.971"
              style="line-height: 1.25;">
            </path>
          </g>
        </g>
      </svg>
    </g>
    <g id="transform" [attr.opacity]="lambdas.transform.colours.opacity">
      <svg x="592" y="1653"
           height="113.438"
           width="96"
           viewBox="0 0 25.4 30.014">
        <g transform="translate(412.599 -86.957)">
          <path d="M-395.754 111.92l8.29-4.786v4.785l-8.29 4.786z"
                [attr.fill]="lambdas.transform.colours.side" fill-rule="evenodd">
          </path>
          <path d="M-404.044 111.92h8.29v4.785h-8.29z"
                [attr.fill]="lambdas.transform.colours.front" fill-rule="evenodd">
          </path>
          <path
            d="M-412.333 107.134v4.785l8.29 4.786v-4.786z" [attr.fill]="lambdas.transform.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 107.134l8.29 4.785h8.289l8.29-4.785M-404.044 111.92v4.785M-395.754 111.92v4.785"
            fill="none" [attr.stroke]="lambdas.transform.colours.highlight" stroke-width=".26588"></path>
          <path
            d="M-412.333 102.348v9.571l8.29 4.786h8.289l8.29-4.786v-9.571l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".53176"></path>
          <path
            d="M-395.754 106.75l8.29-4.786v4.786l-8.29 4.786z" [attr.fill]="lambdas.transform.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 106.75h8.29v4.786h-8.29z" [attr.fill]="lambdas.transform.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.transform.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964l8.29 4.786h8.289l8.29-4.786M-404.044 106.75v4.786M-395.754 106.75v4.786"
            fill="none" [attr.stroke]="lambdas.transform.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 97.178v9.572l8.29 4.786h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".532"></path>
          <path
            d="M-412.333 92.01v4.785l8.29 4.786h8.289l8.29-4.786v-4.786l-8.29-4.786h-8.29z"
            [attr.fill]="lambdas.transform.colours.main" fill-rule="evenodd"></path>
          <path
            d="M-395.754 101.58l8.29-4.785v4.786l-8.29 4.786z" [attr.fill]="lambdas.transform.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 101.58h8.29v4.787h-8.29z" [attr.fill]="lambdas.transform.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.transform.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795l8.29 4.786h8.289l8.29-4.786M-404.044 101.58v4.787M-395.754 101.58v4.787"
            fill="none" [attr.stroke]="lambdas.transform.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 92.01v9.57l8.29 4.787h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none" stroke="#000000"
            stroke-width=".532"></path>
          <circle cx="-136.478"
                  cy="325.284" [attr.fill]="lambdas.transform.colours.background" r="5.801"
                  transform="scale(1.22475 .7071) rotate(45)"></circle>
          <g
            font-family="sans-serif" font-size="3.191" stroke-width=".266" style="line-height: 0%;">
            <path
              d="M-399.242 93.57l.48-.601q.222-.275.177-.448-.04-.17-.467-.416l-.507-.293 1.065-.614.937.541q.825.476.92.934.1.46-.417 1.114l-3.452 4.39-1.622-.937 1.654-2.121-3.729.923-1.622-.936z"
              [attr.fill]="lambdas.transform.colours.text" font-family="Droid Serif" font-size="9.971"
              style="line-height: 1.25;">
            </path>
          </g>
        </g>
      </svg>
    </g>
    <g id="enrich" [attr.opacity]="lambdas.enrich.colours.opacity">
      <svg x="784" y="1542"
           height="113.438"
           width="96"
           viewBox="0 0 25.4 30.014">
        <g transform="translate(412.599 -86.957)">
          <path d="M-395.754 111.92l8.29-4.786v4.785l-8.29 4.786z"
                [attr.fill]="lambdas.enrich.colours.side" fill-rule="evenodd">
          </path>
          <path d="M-404.044 111.92h8.29v4.785h-8.29z"
                [attr.fill]="lambdas.enrich.colours.front" fill-rule="evenodd">
          </path>
          <path
            d="M-412.333 107.134v4.785l8.29 4.786v-4.786z" [attr.fill]="lambdas.enrich.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 107.134l8.29 4.785h8.289l8.29-4.785M-404.044 111.92v4.785M-395.754 111.92v4.785"
            fill="none" [attr.stroke]="lambdas.enrich.colours.highlight" stroke-width=".26588"></path>
          <path
            d="M-412.333 102.348v9.571l8.29 4.786h8.289l8.29-4.786v-9.571l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".53176"></path>
          <path
            d="M-395.754 106.75l8.29-4.786v4.786l-8.29 4.786z" [attr.fill]="lambdas.enrich.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 106.75h8.29v4.786h-8.29z" [attr.fill]="lambdas.enrich.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.enrich.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964l8.29 4.786h8.289l8.29-4.786M-404.044 106.75v4.786M-395.754 106.75v4.786"
            fill="none" [attr.stroke]="lambdas.enrich.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 97.178v9.572l8.29 4.786h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".532"></path>
          <path
            d="M-412.333 92.01v4.785l8.29 4.786h8.289l8.29-4.786v-4.786l-8.29-4.786h-8.29z"
            [attr.fill]="lambdas.enrich.colours.main" fill-rule="evenodd"></path>
          <path
            d="M-395.754 101.58l8.29-4.785v4.786l-8.29 4.786z" [attr.fill]="lambdas.enrich.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 101.58h8.29v4.787h-8.29z" [attr.fill]="lambdas.enrich.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.enrich.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795l8.29 4.786h8.289l8.29-4.786M-404.044 101.58v4.787M-395.754 101.58v4.787"
            fill="none" [attr.stroke]="lambdas.enrich.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 92.01v9.57l8.29 4.787h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none" stroke="#000000"
            stroke-width=".532"></path>
          <circle cx="-136.478"
                  cy="325.284" [attr.fill]="lambdas.enrich.colours.background" r="5.801"
                  transform="scale(1.22475 .7071) rotate(45)"></circle>
          <g
            font-family="sans-serif" font-size="3.191" stroke-width=".266" style="line-height: 0%;">
            <path
              d="M-399.242 93.57l.48-.601q.222-.275.177-.448-.04-.17-.467-.416l-.507-.293 1.065-.614.937.541q.825.476.92.934.1.46-.417 1.114l-3.452 4.39-1.622-.937 1.654-2.121-3.729.923-1.622-.936z"
              [attr.fill]="lambdas.enrich.colours.text" font-family="Droid Serif" font-size="9.971"
              style="line-height: 1.25;">
            </path>
          </g>
        </g>
      </svg>
    </g>
    <g id="combine" [attr.opacity]="lambdas.combine.colours.opacity">
      <svg x="976" y="1431"
           height="113.438"
           width="96"
           viewBox="0 0 25.4 30.014">
        <g transform="translate(412.599 -86.957)">
          <path d="M-395.754 111.92l8.29-4.786v4.785l-8.29 4.786z"
                [attr.fill]="lambdas.combine.colours.side" fill-rule="evenodd">
          </path>
          <path d="M-404.044 111.92h8.29v4.785h-8.29z"
                [attr.fill]="lambdas.combine.colours.front" fill-rule="evenodd">
          </path>
          <path
            d="M-412.333 107.134v4.785l8.29 4.786v-4.786z" [attr.fill]="lambdas.combine.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 107.134l8.29 4.785h8.289l8.29-4.785M-404.044 111.92v4.785M-395.754 111.92v4.785"
            fill="none" [attr.stroke]="lambdas.combine.colours.highlight" stroke-width=".26588"></path>
          <path
            d="M-412.333 102.348v9.571l8.29 4.786h8.289l8.29-4.786v-9.571l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".53176"></path>
          <path
            d="M-395.754 106.75l8.29-4.786v4.786l-8.29 4.786z" [attr.fill]="lambdas.combine.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 106.75h8.29v4.786h-8.29z" [attr.fill]="lambdas.combine.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.combine.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964l8.29 4.786h8.289l8.29-4.786M-404.044 106.75v4.786M-395.754 106.75v4.786"
            fill="none" [attr.stroke]="lambdas.combine.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 97.178v9.572l8.29 4.786h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".532"></path>
          <path
            d="M-412.333 92.01v4.785l8.29 4.786h8.289l8.29-4.786v-4.786l-8.29-4.786h-8.29z"
            [attr.fill]="lambdas.combine.colours.main" fill-rule="evenodd"></path>
          <path
            d="M-395.754 101.58l8.29-4.785v4.786l-8.29 4.786z" [attr.fill]="lambdas.combine.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 101.58h8.29v4.787h-8.29z" [attr.fill]="lambdas.combine.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.combine.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795l8.29 4.786h8.289l8.29-4.786M-404.044 101.58v4.787M-395.754 101.58v4.787"
            fill="none" [attr.stroke]="lambdas.combine.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 92.01v9.57l8.29 4.787h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none" stroke="#000000"
            stroke-width=".532"></path>
          <circle cx="-136.478"
                  cy="325.284" [attr.fill]="lambdas.combine.colours.background" r="5.801"
                  transform="scale(1.22475 .7071) rotate(45)"></circle>
          <g
            font-family="sans-serif" font-size="3.191" stroke-width=".266" style="line-height: 0%;">
            <path
              d="M-399.242 93.57l.48-.601q.222-.275.177-.448-.04-.17-.467-.416l-.507-.293 1.065-.614.937.541q.825.476.92.934.1.46-.417 1.114l-3.452 4.39-1.622-.937 1.654-2.121-3.729.923-1.622-.936z"
              [attr.fill]="lambdas.combine.colours.text" font-family="Droid Serif" font-size="9.971"
              style="line-height: 1.25;">
            </path>
          </g>
        </g>
      </svg>
    </g>
    <g id="encapsulate" [attr.opacity]="lambdas.encapsulate.colours.opacity">
      <svg x="1168" y="1320"
           height="113.438"
           width="96"
           viewBox="0 0 25.4 30.014">
        <g transform="translate(412.599 -86.957)">
          <path d="M-395.754 111.92l8.29-4.786v4.785l-8.29 4.786z"
                [attr.fill]="lambdas.encapsulate.colours.side" fill-rule="evenodd">
          </path>
          <path d="M-404.044 111.92h8.29v4.785h-8.29z"
                [attr.fill]="lambdas.encapsulate.colours.front" fill-rule="evenodd">
          </path>
          <path
            d="M-412.333 107.134v4.785l8.29 4.786v-4.786z" [attr.fill]="lambdas.encapsulate.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 107.134l8.29 4.785h8.289l8.29-4.785M-404.044 111.92v4.785M-395.754 111.92v4.785"
            fill="none" [attr.stroke]="lambdas.encapsulate.colours.highlight" stroke-width=".26588"></path>
          <path
            d="M-412.333 102.348v9.571l8.29 4.786h8.289l8.29-4.786v-9.571l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".53176"></path>
          <path
            d="M-395.754 106.75l8.29-4.786v4.786l-8.29 4.786z" [attr.fill]="lambdas.encapsulate.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 106.75h8.29v4.786h-8.29z" [attr.fill]="lambdas.encapsulate.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.encapsulate.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964l8.29 4.786h8.289l8.29-4.786M-404.044 106.75v4.786M-395.754 106.75v4.786"
            fill="none" [attr.stroke]="lambdas.encapsulate.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 97.178v9.572l8.29 4.786h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".532"></path>
          <path
            d="M-412.333 92.01v4.785l8.29 4.786h8.289l8.29-4.786v-4.786l-8.29-4.786h-8.29z"
            [attr.fill]="lambdas.encapsulate.colours.main" fill-rule="evenodd"></path>
          <path
            d="M-395.754 101.58l8.29-4.785v4.786l-8.29 4.786z" [attr.fill]="lambdas.encapsulate.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 101.58h8.29v4.787h-8.29z" [attr.fill]="lambdas.encapsulate.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.encapsulate.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795l8.29 4.786h8.289l8.29-4.786M-404.044 101.58v4.787M-395.754 101.58v4.787"
            fill="none" [attr.stroke]="lambdas.encapsulate.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 92.01v9.57l8.29 4.787h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none" stroke="#000000"
            stroke-width=".532"></path>
          <circle cx="-136.478"
                  cy="325.284" [attr.fill]="lambdas.encapsulate.colours.background" r="5.801"
                  transform="scale(1.22475 .7071) rotate(45)"></circle>
          <g
            font-family="sans-serif" font-size="3.191" stroke-width=".266" style="line-height: 0%;">
            <path
              d="M-399.242 93.57l.48-.601q.222-.275.177-.448-.04-.17-.467-.416l-.507-.293 1.065-.614.937.541q.825.476.92.934.1.46-.417 1.114l-3.452 4.39-1.622-.937 1.654-2.121-3.729.923-1.622-.936z"
              [attr.fill]="lambdas.encapsulate.colours.text" font-family="Droid Serif" font-size="9.971"
              style="line-height: 1.25;">
            </path>
          </g>
        </g>
      </svg>
    </g>
    <g id="publish" [attr.opacity]="lambdas.publish.colours.opacity">
      <svg x="1360" y="1209"
           height="113.438"
           width="96"
           viewBox="0 0 25.4 30.014">
        <g transform="translate(412.599 -86.957)">
          <path d="M-395.754 111.92l8.29-4.786v4.785l-8.29 4.786z"
                [attr.fill]="lambdas.publish.colours.side" fill-rule="evenodd">
          </path>
          <path d="M-404.044 111.92h8.29v4.785h-8.29z"
                [attr.fill]="lambdas.publish.colours.front" fill-rule="evenodd">
          </path>
          <path
            d="M-412.333 107.134v4.785l8.29 4.786v-4.786z" [attr.fill]="lambdas.publish.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 107.134l8.29 4.785h8.289l8.29-4.785M-404.044 111.92v4.785M-395.754 111.92v4.785"
            fill="none" [attr.stroke]="lambdas.publish.colours.highlight" stroke-width=".26588"></path>
          <path
            d="M-412.333 102.348v9.571l8.29 4.786h8.289l8.29-4.786v-9.571l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".53176"></path>
          <path
            d="M-395.754 106.75l8.29-4.786v4.786l-8.29 4.786z" [attr.fill]="lambdas.publish.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 106.75h8.29v4.786h-8.29z" [attr.fill]="lambdas.publish.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.publish.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964l8.29 4.786h8.289l8.29-4.786M-404.044 106.75v4.786M-395.754 106.75v4.786"
            fill="none" [attr.stroke]="lambdas.publish.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 97.178v9.572l8.29 4.786h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".532"></path>
          <path
            d="M-412.333 92.01v4.785l8.29 4.786h8.289l8.29-4.786v-4.786l-8.29-4.786h-8.29z"
            [attr.fill]="lambdas.publish.colours.main" fill-rule="evenodd"></path>
          <path
            d="M-395.754 101.58l8.29-4.785v4.786l-8.29 4.786z" [attr.fill]="lambdas.publish.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 101.58h8.29v4.787h-8.29z" [attr.fill]="lambdas.publish.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.publish.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795l8.29 4.786h8.289l8.29-4.786M-404.044 101.58v4.787M-395.754 101.58v4.787"
            fill="none" [attr.stroke]="lambdas.publish.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 92.01v9.57l8.29 4.787h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none" stroke="#000000"
            stroke-width=".532"></path>
          <circle cx="-136.478"
                  cy="325.284" [attr.fill]="lambdas.publish.colours.background" r="5.801"
                  transform="scale(1.22475 .7071) rotate(45)"></circle>
          <g
            font-family="sans-serif" font-size="3.191" stroke-width=".266" style="line-height: 0%;">
            <path
              d="M-399.242 93.57l.48-.601q.222-.275.177-.448-.04-.17-.467-.416l-.507-.293 1.065-.614.937.541q.825.476.92.934.1.46-.417 1.114l-3.452 4.39-1.622-.937 1.654-2.121-3.729.923-1.622-.936z"
              [attr.fill]="lambdas.publish.colours.text" font-family="Droid Serif" font-size="9.971"
              style="line-height: 1.25;">
            </path>
          </g>
        </g>
      </svg>
    </g>

    <g id="validatePayload" [attr.opacity]="lambdas.validatePayload.colours.opacity">
      <svg
        x="240" y="1672" height="113.438" width="96" viewBox="0 0 25.4 30.014">
        <g transform="translate(412.599 -86.957)">
          <path d="M-395.754 111.92l8.29-4.786v4.785l-8.29 4.786z"
                [attr.fill]="lambdas.validatePayload.colours.side" fill-rule="evenodd">
          </path>
          <path d="M-404.044 111.92h8.29v4.785h-8.29z"
                [attr.fill]="lambdas.validatePayload.colours.front" fill-rule="evenodd">
          </path>
          <path
            d="M-412.333 107.134v4.785l8.29 4.786v-4.786z" [attr.fill]="lambdas.validatePayload.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 107.134l8.29 4.785h8.289l8.29-4.785M-404.044 111.92v4.785M-395.754 111.92v4.785"
            fill="none" [attr.stroke]="lambdas.validatePayload.colours.highlight" stroke-width=".26588"></path>
          <path
            d="M-412.333 102.348v9.571l8.29 4.786h8.289l8.29-4.786v-9.571l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".53176"></path>
          <path
            d="M-395.754 106.75l8.29-4.786v4.786l-8.29 4.786z" [attr.fill]="lambdas.validatePayload.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 106.75h8.29v4.786h-8.29z" [attr.fill]="lambdas.validatePayload.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.validatePayload.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964l8.29 4.786h8.289l8.29-4.786M-404.044 106.75v4.786M-395.754 106.75v4.786"
            fill="none" [attr.stroke]="lambdas.validatePayload.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 97.178v9.572l8.29 4.786h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".532"></path>
          <path
            d="M-412.333 92.01v4.785l8.29 4.786h8.289l8.29-4.786v-4.786l-8.29-4.786h-8.29z"
            [attr.fill]="lambdas.validatePayload.colours.main" fill-rule="evenodd"></path>
          <path
            d="M-395.754 101.58l8.29-4.785v4.786l-8.29 4.786z" [attr.fill]="lambdas.validatePayload.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 101.58h8.29v4.787h-8.29z" [attr.fill]="lambdas.validatePayload.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.validatePayload.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795l8.29 4.786h8.289l8.29-4.786M-404.044 101.58v4.787M-395.754 101.58v4.787"
            fill="none" [attr.stroke]="lambdas.validatePayload.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 92.01v9.57l8.29 4.787h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none" stroke="#000000"
            stroke-width=".532"></path>
          <circle cx="-136.478"
                  cy="325.284" [attr.fill]="lambdas.validatePayload.colours.background" r="5.801"
                  transform="scale(1.22475 .7071) rotate(45)"></circle>
          <g
            font-family="sans-serif" font-size="3.191" stroke-width=".266" style="line-height: 0%;">
            <path
              d="M-399.242 93.57l.48-.601q.222-.275.177-.448-.04-.17-.467-.416l-.507-.293 1.065-.614.937.541q.825.476.92.934.1.46-.417 1.114l-3.452 4.39-1.622-.937 1.654-2.121-3.729.923-1.622-.936z"
              [attr.fill]="lambdas.validatePayload.colours.text" font-family="Droid Serif" font-size="9.971" style="line-height:
1.25;">
            </path>
          </g>
        </g>
      </svg>
    </g>
    <g id="validateEncapsulated" [attr.opacity]="lambdas.validateEncapsulated.colours.opacity">
      <svg
        x="1008" y="1228" height="113.438" width="96" viewBox="0 0 25.4 30.014">
        <g transform="translate(412.599 -86.957)">
          <path d="M-395.754 111.92l8.29-4.786v4.785l-8.29 4.786z"
                [attr.fill]="lambdas.validateEncapsulated.colours.side" fill-rule="evenodd">
          </path>
          <path d="M-404.044 111.92h8.29v4.785h-8.29z"
                [attr.fill]="lambdas.validateEncapsulated.colours.front" fill-rule="evenodd">
          </path>
          <path
            d="M-412.333 107.134v4.785l8.29 4.786v-4.786z" [attr.fill]="lambdas.validateEncapsulated.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 107.134l8.29 4.785h8.289l8.29-4.785M-404.044 111.92v4.785M-395.754 111.92v4.785"
            fill="none" [attr.stroke]="lambdas.validateEncapsulated.colours.highlight" stroke-width=".26588"></path>
          <path
            d="M-412.333 102.348v9.571l8.29 4.786h8.289l8.29-4.786v-9.571l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".53176"></path>
          <path
            d="M-395.754 106.75l8.29-4.786v4.786l-8.29 4.786z" [attr.fill]="lambdas.validateEncapsulated.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 106.75h8.29v4.786h-8.29z" [attr.fill]="lambdas.validateEncapsulated.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.validateEncapsulated.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964l8.29 4.786h8.289l8.29-4.786M-404.044 106.75v4.786M-395.754 106.75v4.786"
            fill="none" [attr.stroke]="lambdas.validateEncapsulated.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 97.178v9.572l8.29 4.786h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".532"></path>
          <path
            d="M-412.333 92.01v4.785l8.29 4.786h8.289l8.29-4.786v-4.786l-8.29-4.786h-8.29z"
            [attr.fill]="lambdas.validateEncapsulated.colours.main" fill-rule="evenodd"></path>
          <path
            d="M-395.754 101.58l8.29-4.785v4.786l-8.29 4.786z" [attr.fill]="lambdas.validateEncapsulated.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 101.58h8.29v4.787h-8.29z" [attr.fill]="lambdas.validateEncapsulated.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.validateEncapsulated.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795l8.29 4.786h8.289l8.29-4.786M-404.044 101.58v4.787M-395.754 101.58v4.787"
            fill="none" [attr.stroke]="lambdas.validateEncapsulated.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 92.01v9.57l8.29 4.787h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none" stroke="#000000"
            stroke-width=".532"></path>
          <circle cx="-136.478"
                  cy="325.284" [attr.fill]="lambdas.validateEncapsulated.colours.background" r="5.801"
                  transform="scale(1.22475 .7071) rotate(45)"></circle>
          <g
            font-family="sans-serif" font-size="3.191" stroke-width=".266" style="line-height: 0%;">
            <path
              d="M-399.242 93.57l.48-.601q.222-.275.177-.448-.04-.17-.467-.416l-.507-.293 1.065-.614.937.541q.825.476.92.934.1.46-.417 1.114l-3.452 4.39-1.622-.937 1.654-2.121-3.729.923-1.622-.936z"
              [attr.fill]="lambdas.validateEncapsulated.colours.text" font-family="Droid Serif" font-size="9.971"
              style="line-height:
1.25;">
            </path>
          </g>
        </g>
      </svg>
    </g>

    <g id="regXchangeGet" [attr.opacity]="lambdas.regXchangeGet.colours.opacity">
      <svg x="1360" y="1764"
           height="113.438"
           width="96"
           viewBox="0 0 25.4 30.014">
        <g transform="translate(412.599 -86.957)">
          <path d="M-395.754 111.92l8.29-4.786v4.785l-8.29 4.786z"
                [attr.fill]="lambdas.regXchangeGet.colours.side" fill-rule="evenodd">
          </path>
          <path d="M-404.044 111.92h8.29v4.785h-8.29z"
                [attr.fill]="lambdas.regXchangeGet.colours.front" fill-rule="evenodd">
          </path>
          <path
            d="M-412.333 107.134v4.785l8.29 4.786v-4.786z" [attr.fill]="lambdas.regXchangeGet.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 107.134l8.29 4.785h8.289l8.29-4.785M-404.044 111.92v4.785M-395.754 111.92v4.785"
            fill="none" [attr.stroke]="lambdas.regXchangeGet.colours.highlight" stroke-width=".26588"></path>
          <path
            d="M-412.333 102.348v9.571l8.29 4.786h8.289l8.29-4.786v-9.571l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".53176"></path>
          <path
            d="M-395.754 106.75l8.29-4.786v4.786l-8.29 4.786z" [attr.fill]="lambdas.regXchangeGet.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 106.75h8.29v4.786h-8.29z" [attr.fill]="lambdas.regXchangeGet.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.regXchangeGet.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964l8.29 4.786h8.289l8.29-4.786M-404.044 106.75v4.786M-395.754 106.75v4.786"
            fill="none" [attr.stroke]="lambdas.regXchangeGet.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 97.178v9.572l8.29 4.786h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".532"></path>
          <path
            d="M-412.333 92.01v4.785l8.29 4.786h8.289l8.29-4.786v-4.786l-8.29-4.786h-8.29z"
            [attr.fill]="lambdas.regXchangeGet.colours.main" fill-rule="evenodd"></path>
          <path
            d="M-395.754 101.58l8.29-4.785v4.786l-8.29 4.786z" [attr.fill]="lambdas.regXchangeGet.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 101.58h8.29v4.787h-8.29z" [attr.fill]="lambdas.regXchangeGet.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.regXchangeGet.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795l8.29 4.786h8.289l8.29-4.786M-404.044 101.58v4.787M-395.754 101.58v4.787"
            fill="none" [attr.stroke]="lambdas.regXchangeGet.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 92.01v9.57l8.29 4.787h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none" stroke="#000000"
            stroke-width=".532"></path>
          <circle cx="-136.478"
                  cy="325.284" [attr.fill]="lambdas.regXchangeGet.colours.background" r="5.801"
                  transform="scale(1.22475 .7071) rotate(45)"></circle>
          <g
            font-family="sans-serif" font-size="3.191" stroke-width=".266" style="line-height: 0%;">
            <path
              d="M-399.242 93.57l.48-.601q.222-.275.177-.448-.04-.17-.467-.416l-.507-.293 1.065-.614.937.541q.825.476.92.934.1.46-.417 1.114l-3.452 4.39-1.622-.937 1.654-2.121-3.729.923-1.622-.936z"
              [attr.fill]="lambdas.regXchangeGet.colours.text" font-family="Droid Serif" font-size="9.971"
              style="line-height: 1.25;">
            </path>
          </g>
        </g>
      </svg>
    </g>

    <g id="generateDiff" [attr.opacity]="lambdas.generateDiff.colours.opacity">
      <svg x="2032" y="1376"
           height="113.438"
           width="96"
           viewBox="0 0 25.4 30.014">
        <g transform="translate(412.599 -86.957)">
          <path d="M-395.754 111.92l8.29-4.786v4.785l-8.29 4.786z"
                [attr.fill]="lambdas.generateDiff.colours.side" fill-rule="evenodd">
          </path>
          <path d="M-404.044 111.92h8.29v4.785h-8.29z"
                [attr.fill]="lambdas.generateDiff.colours.front" fill-rule="evenodd">
          </path>
          <path
            d="M-412.333 107.134v4.785l8.29 4.786v-4.786z" [attr.fill]="lambdas.generateDiff.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 107.134l8.29 4.785h8.289l8.29-4.785M-404.044 111.92v4.785M-395.754 111.92v4.785"
            fill="none" [attr.stroke]="lambdas.generateDiff.colours.highlight" stroke-width=".26588"></path>
          <path
            d="M-412.333 102.348v9.571l8.29 4.786h8.289l8.29-4.786v-9.571l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".53176"></path>
          <path
            d="M-395.754 106.75l8.29-4.786v4.786l-8.29 4.786z" [attr.fill]="lambdas.generateDiff.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 106.75h8.29v4.786h-8.29z" [attr.fill]="lambdas.generateDiff.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.generateDiff.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964l8.29 4.786h8.289l8.29-4.786M-404.044 106.75v4.786M-395.754 106.75v4.786"
            fill="none" [attr.stroke]="lambdas.generateDiff.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 97.178v9.572l8.29 4.786h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".532"></path>
          <path
            d="M-412.333 92.01v4.785l8.29 4.786h8.289l8.29-4.786v-4.786l-8.29-4.786h-8.29z"
            [attr.fill]="lambdas.generateDiff.colours.main" fill-rule="evenodd"></path>
          <path
            d="M-395.754 101.58l8.29-4.785v4.786l-8.29 4.786z" [attr.fill]="lambdas.generateDiff.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 101.58h8.29v4.787h-8.29z" [attr.fill]="lambdas.generateDiff.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.generateDiff.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795l8.29 4.786h8.289l8.29-4.786M-404.044 101.58v4.787M-395.754 101.58v4.787"
            fill="none" [attr.stroke]="lambdas.generateDiff.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 92.01v9.57l8.29 4.787h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none" stroke="#000000"
            stroke-width=".532"></path>
          <circle cx="-136.478"
                  cy="325.284" [attr.fill]="lambdas.generateDiff.colours.background" r="5.801"
                  transform="scale(1.22475 .7071) rotate(45)"></circle>
          <g
            font-family="sans-serif" font-size="3.191" stroke-width=".266" style="line-height: 0%;">
            <path
              d="M-399.242 93.57l.48-.601q.222-.275.177-.448-.04-.17-.467-.416l-.507-.293 1.065-.614.937.541q.825.476.92.934.1.46-.417 1.114l-3.452 4.39-1.622-.937 1.654-2.121-3.729.923-1.622-.936z"
              [attr.fill]="lambdas.generateDiff.colours.text" font-family="Droid Serif" font-size="9.971"
              style="line-height: 1.25;">
            </path>
          </g>
        </g>
      </svg>
    </g>
    <g id="raiseJira" [attr.opacity]="lambdas.raiseJira.colours.opacity">
      <svg x="944" y="2005"
           height="113.438"
           width="96"
           viewBox="0 0 25.4 30.014">
        <g transform="translate(412.599 -86.957)">
          <path d="M-395.754 111.92l8.29-4.786v4.785l-8.29 4.786z"
                [attr.fill]="lambdas.raiseJira.colours.side" fill-rule="evenodd">
          </path>
          <path d="M-404.044 111.92h8.29v4.785h-8.29z"
                [attr.fill]="lambdas.raiseJira.colours.front" fill-rule="evenodd">
          </path>
          <path
            d="M-412.333 107.134v4.785l8.29 4.786v-4.786z" [attr.fill]="lambdas.raiseJira.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 107.134l8.29 4.785h8.289l8.29-4.785M-404.044 111.92v4.785M-395.754 111.92v4.785"
            fill="none" [attr.stroke]="lambdas.raiseJira.colours.highlight" stroke-width=".26588"></path>
          <path
            d="M-412.333 102.348v9.571l8.29 4.786h8.289l8.29-4.786v-9.571l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".53176"></path>
          <path
            d="M-395.754 106.75l8.29-4.786v4.786l-8.29 4.786z" [attr.fill]="lambdas.raiseJira.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 106.75h8.29v4.786h-8.29z" [attr.fill]="lambdas.raiseJira.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.raiseJira.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964l8.29 4.786h8.289l8.29-4.786M-404.044 106.75v4.786M-395.754 106.75v4.786"
            fill="none" [attr.stroke]="lambdas.raiseJira.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 97.178v9.572l8.29 4.786h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".532"></path>
          <path
            d="M-412.333 92.01v4.785l8.29 4.786h8.289l8.29-4.786v-4.786l-8.29-4.786h-8.29z"
            [attr.fill]="lambdas.raiseJira.colours.main" fill-rule="evenodd"></path>
          <path
            d="M-395.754 101.58l8.29-4.785v4.786l-8.29 4.786z" [attr.fill]="lambdas.raiseJira.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 101.58h8.29v4.787h-8.29z" [attr.fill]="lambdas.raiseJira.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.raiseJira.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795l8.29 4.786h8.289l8.29-4.786M-404.044 101.58v4.787M-395.754 101.58v4.787"
            fill="none" [attr.stroke]="lambdas.raiseJira.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 92.01v9.57l8.29 4.787h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none" stroke="#000000"
            stroke-width=".532"></path>
          <circle cx="-136.478"
                  cy="325.284" [attr.fill]="lambdas.raiseJira.colours.background" r="5.801"
                  transform="scale(1.22475 .7071) rotate(45)"></circle>
          <g
            font-family="sans-serif" font-size="3.191" stroke-width=".266" style="line-height: 0%;">
            <path
              d="M-399.242 93.57l.48-.601q.222-.275.177-.448-.04-.17-.467-.416l-.507-.293 1.065-.614.937.541q.825.476.92.934.1.46-.417 1.114l-3.452 4.39-1.622-.937 1.654-2.121-3.729.923-1.622-.936z"
              [attr.fill]="lambdas.raiseJira.colours.text" font-family="Droid Serif" font-size="9.971"
              style="line-height: 1.25;">
            </path>
          </g>
        </g>
      </svg>
    </g>

    <g id="regxchange-publish-base">
      <polygon points="1600 1092, 1696 1147, 1600 1203, 1504 1147"
               [attr.fill]="lambdas.regXchangePublish.colours.main"></polygon>
      <polygon points="1504 1184, 1600 1240, 1600 1203, 1504 1147" [attr.fill]="lambdas.regXchangePublish.colours.front"
               [attr.stroke]="lambdas.regXchangePublish.colours.highlight"></polygon>
      <polygon points="1600 1240, 1696 1184, 1696 1147, 1600 1203" [attr.fill]="lambdas.regXchangePublish.colours.side"
               [attr.stroke]="lambdas.regXchangePublish.colours.highlight"></polygon>
      <polygon points="1600 1092, 1504 1147, 1504 1184, 1600 1240, 1696 1184, 1696 1147" fill="none"
               stroke="#000000" stroke-width="2"></polygon>
    </g>
    <g id="regxchange-get-base">
      <polygon points="1184 1887, 1280 1943, 1184 1998, 1088 1943"
               [attr.fill]="lambdas.regXchangeGet.colours.main"></polygon>
      <polygon points="1088 1980, 1184 2035, 1184 1998, 1088 1943" [attr.fill]="lambdas.regXchangeGet.colours.front"
               [attr.stroke]="lambdas.regXchangeGet.colours.highlight"></polygon>
      <polygon points="1184 2035, 1280 1980, 1280 1943, 1184 1998" [attr.fill]="lambdas.regXchangeGet.colours.side"
               [attr.stroke]="lambdas.regXchangeGet.colours.highlight"></polygon>
      <polygon points="1184 1887, 1088 1943, 1088 1980, 1184 2035, 1280 1980, 1280 1943" fill="none"
               stroke="#000000" stroke-width="2"></polygon>
    </g>
  </g>
  <g id="apigateway" [attr.opacity]="apigateway.colours.opacity">
    <svg id="api" x="210"
         y="1880"
         height="108.05"
         width="123"
         viewBox="0 0 32.544 28.588">
      <path d="M10.115 6.02v14.218l7.873-4.318V1.474z"
            [attr.fill]="apigateway.colours.highlight" fill-rule="evenodd" [attr.stroke]="apigateway.colours.highlight"
            stroke-width=".268">
      </path>
      <path
        d="M.265 2.228l9.85 3.791v14.219l-9.85-8.531z" [attr.fill]="apigateway.colours.front" fill-rule="evenodd"
        [attr.stroke]="apigateway.colours.highlight" stroke-width=".265"></path>
      <path
        d="M10.115 6.02l7.873-4.546L3.548.332.265 2.228z" [attr.fill]="apigateway.colours.main" fill-rule="evenodd"
        [attr.stroke]="apigateway.colours.highlight" stroke-width=".265"></path>
      <path
        d="M.265 11.707l9.85 8.53 7.873-4.317V1.474L3.392.271.265 2.076z" fill="none" fill-rule="evenodd"
        stroke="#000000"
        stroke-width=".529"></path>
      <path
        d="M22.429 3.65L14.22 8.39l14.828 10.397 3.231-1.866z" [attr.fill]="apigateway.colours.main" fill-rule="evenodd"
        stroke="#fff8f7" stroke-width=".268"></path>
      <path
        d="M14.22 8.39V22.61l14.777 5.687.051-9.509z" [attr.fill]="apigateway.colours.front" fill-rule="evenodd"
        [attr.stroke]="apigateway.colours.highlight" stroke-width=".265"></path>
      <path
        d="M29.048 18.787l3.231-1.866V26.4l-3.282 1.897z" [attr.fill]="apigateway.colours.highlight" fill-rule="evenodd"
        [attr.stroke]="apigateway.colours.highlight" stroke-width=".265"></path>
      <path
        d="M22.429 3.65L14.22 8.39V22.61l14.777 5.687 3.282-1.897v-9.478z" fill="none" fill-rule="evenodd"
        stroke="#000000"
        stroke-width=".529"></path>
    </svg>
  </g>
  <g id="icons">
    <g id="credit-suisse">
      <svg x="208" y="2044" overflow="visible" [attr.opacity]="icons.creditSuisse.colours.opacity">
        <g transform="scale(0.9905000000000002) matrix(0.707 0.409 -0.707 0.409 0 0)">
          <svg x="-304.5" y="-67.5" width="609" height="135">
            <svg width="609.057" height="135.72" viewBox="0 0 161.146 35.909">
              <g>
                <g>
                  <path
                    d="M71.306 21.939H60.74v2.425h.346c.087-.347.693-1.04 1.472-1.04h2.339V35.71h2.338V23.324h2.425c.78 0 1.3.433 1.386.866v.087h.347zM2.452 21.16C.892 22.717.026 24.97.026 27.134c0 2.512 1.04 4.764 2.772 6.323 1.732 1.559 4.07 2.425 6.496 2.425 1.299 0 3.81-.26 6.322-1.732l.087-.087.26-3.464-.433-.087-.087.173c-1.819 3.724-4.59 3.724-5.716 3.724-4.764 0-6.929-3.984-6.929-7.621 0-3.551 2.165-7.189 6.929-7.189 1.472 0 4.157.52 5.543 3.724l.086.174.433-.174-.173-3.55-.086-.087c-2.252-.953-4.071-1.386-5.89-1.386-2.945.087-5.456 1.04-7.188 2.858zM18.301 21.939l-.087.346c.174.087.433.606.433 1.213v12.125H20.9v-6.236h.953c.866.087 1.213.606 1.732 1.386l.087.086.26.52c.52.78 1.126 1.905 1.818 2.945.52.78 1.126 1.126 1.906 1.299.52.087 1.645.087 2.078-.087l.52-.086.173-.087-.693-.173c-.26-.087-.692-.26-1.299-.953-.346-.433-.952-1.386-1.818-2.771l-.867-1.386c-.26-.347-.606-.866-1.299-1.3 1.3-.432 2.512-1.558 2.512-3.29 0-.52-.087-1.473-.953-2.252-.866-.78-2.165-1.213-3.984-1.213zm3.897 1.299c2.339.086 2.426 2.078 2.426 2.338 0 1.992-1.473 2.685-2.685 2.685h-.953v-4.937c.26-.086.693-.173 1.212-.086zM41.599 21.939v.346c.173.087.346.606.346 1.04v12.298h3.898c2.598 0 4.677-.78 6.15-2.339 1.212-1.299 1.904-2.944 1.904-4.763 0-1.04-.346-2.685-1.385-3.984-1.386-1.732-3.465-2.685-6.323-2.685zm2.685 1.385h1.212c.347 0 1.126 0 1.733.087 3.81.606 4.243 3.81 4.243 5.197 0 1.125-.173 2.684-1.125 3.984-.953 1.212-2.426 1.818-4.418 1.818h-1.645V23.324zM58.661 21.939h-2.685v.346c.26.087.433.606.433 1.126v12.212h2.252zM104.564 21.939h-2.685v.346c.26.087.433.606.433 1.126v12.212h2.252zM38.654 21.939h-7.621l.086.346c.173.087.433.606.433 1.213v12.125h7.622l.52-2.425-.347-.087-.086.173c-.607.953-1.3 1.126-3.465 1.126-.78 0-1.559-.086-2.078-.086V28.78h3.897v-1.3h-3.897v-4.243h3.117c.693 0 1.473.693 1.56 1.126v.086h.346zM136.35 21.939h-7.622v.346c.173.087.433.52.433 1.213v12.125h7.622l.52-2.425-.347-.087-.087.173c-.606.953-1.299 1.126-3.464 1.126-.78 0-1.56-.086-2.079-.086V28.78h3.898v-1.3h-3.898v-4.243h3.118c.866 0 1.473.693 1.473 1.126v.086h.346zM77.975 19.427c-.78.606-1.732 1.646-1.819 3.464v.087c0 2.165 1.386 3.378 3.638 4.504.086.086.26.173.866.433 1.905.952 3.204 1.645 3.204 3.55 0 .694-.26 1.646-.952 2.34-.607.605-1.386.865-2.339.865-2.858 0-3.897-2.511-4.157-3.637l-.087-.174-.52.087.174 3.551.26-.087c.952.52 2.425 1.386 4.677 1.473 1.559 0 3.118-.607 4.243-1.732.953-.953 1.473-2.166 1.473-3.465 0-2.858-2.079-3.984-4.244-5.11l-.433-.26c-2.252-1.126-3.291-1.818-3.291-3.204 0-.953.78-2.512 2.685-2.512 2.252 0 3.464 1.732 3.724 2.772l.086.173.52-.087-.173-3.118-.087-.086c-1.299-.866-2.944-1.04-3.637-1.04-1.56.087-2.858.52-3.811 1.213zM108.288 25.403c0 1.905 1.126 2.858 2.945 3.81l.693.347c1.472.693 2.425 1.213 2.425 2.599 0 .26-.087 1.039-.693 1.732-.433.433-1.04.693-1.819.606-2.165 0-2.945-1.732-3.291-2.685l-.087-.173-.433.086.087 2.859.087.086c.692.433 1.905 1.126 3.724 1.126 1.212 0 2.511-.52 3.378-1.386.779-.78 1.125-1.732 1.125-2.771 0-2.425-1.645-3.291-3.377-4.157l-.347-.174c-1.905-.952-2.511-1.385-2.511-2.425 0-.78.52-1.818 2.078-1.818 1.819 0 2.598 1.385 2.772 2.078l.086.173.433-.086-.173-2.512-.086-.086c-1.04-.693-2.339-.78-2.859-.78-1.992 0-4.157 1.213-4.157 3.551zM118.508 25.403c0 1.905 1.126 2.858 2.945 3.81l.693.347c1.472.693 2.425 1.213 2.425 2.599 0 .26-.087 1.039-.693 1.732-.433.433-1.04.693-1.819.606-2.165 0-2.945-1.732-3.291-2.685l-.087-.173-.433.086.087 2.859.086.086c.693.433 1.906 1.126 3.725 1.126 1.212 0 2.511-.52 3.377-1.386.78-.78 1.126-1.732 1.126-2.771 0-2.425-1.645-3.291-3.377-4.157l-.347-.174c-1.905-.952-2.511-1.385-2.511-2.425 0-.433.173-.952.52-1.299.346-.346.865-.52 1.472-.52 1.818 0 2.598 1.386 2.771 2.08l.087.172.433-.086-.174-2.512-.086-.086c-1.04-.693-2.339-.78-2.858-.78-1.82 0-4.07 1.213-4.07 3.551zM98.934 21.939h-1.818v.346c.086.087.346.26.346 1.126v7.795c0 1.472-.52 3.291-3.205 3.291-2.511 0-3.03-1.472-3.03-3.724v-8.834h-2.859v.346c.173.087.52.433.52 1.213v7.275c0 4.503 2.944 5.023 5.196 5.023 1.126 0 4.677-.346 4.677-4.59z"
                    [attr.fill]="icons.creditSuisse.colours.main"></path>
                  <g>
                    <path
                      d="M156.01 18.041a25.635 25.635 0 0 1 5.11 2.252C156.703 13.018 148.908 5.136 141.2.026c1.992 1.992 5.196 6.323 6.062 10.913a103.922 103.922 0 0 1 8.748 7.102z"
                      [attr.fill]="icons.creditSuisse.colours.main"></path>
                    <path
                      d="M156.01 18.041c-3.81-1.212-7.015-1.299-9.354-1.04.866-1.991.953-4.07.606-6.062-5.802-4.157-12.298-7.795-18.447-10.48 4.503 3.032 9.527 11.953 11.605 21.48 4.504-1.3 11.346-2.252 20.267.78a119.055 119.055 0 0 0-4.677-4.678z"
                      [attr.fill]="icons.creditSuisse.colours.main"></path>
                    <path
                      d="M147.176 10.94c.346 1.991.26 4.07-.52 6.062 2.425-.26 5.63-.173 9.354 1.04-2.685-2.426-5.63-4.85-8.834-7.103z"
                      fill="none"></path>
                  </g>
                </g>
              </g>
            </svg>
          </svg>
        </g>
      </svg>
    </g>
    <g id="regxchange-publish">
      <svg x="1600" y="1147" overflow="visible" [attr.opacity]="icons.regXchangePublish.colours.opacity">
        <g transform="scale(1.415) matrix(0.707 0.409 -0.707 0.409 0 0)">
          <svg x="-44" y="-44" width="88" height="88">
            <svg width="88" height="88" viewBox="0 0 88 88">
              <rect [attr.fill]="icons.regXchangePublish.colours.main" width="88" height="88"/>
              <path fill="#231F20" d="M25.66,12.26h14.51l18.28,22.33L25.66,75.61H11.01c11.26-13.63,22.51-27.26,33.77-40.88
	C38.4,27.24,32.03,19.75,25.66,12.26z"/>
              <polygon fill="#FFFFFF" points="62.63,12.26 55.24,21.61 62.63,30.54 76.59,12.26 "/>
              <polygon fill="#FFFFFF" points="62.36,56.5 76.59,56.5 62.36,39.05 55.24,47.77 "/>
            </svg>
          </svg>
        </g>
      </svg>
    </g>
    <g id="regxchange-get" [attr.opacity]="icons.regXchangeGet.colours.opacity">
      <svg x="1184" y="1943" overflow="visible">
        <g transform="scale(1.415) matrix(0.707 0.409 -0.707 0.409 0 0)">
          <svg x="-44" y="-44" width="88" height="88">
            <svg width="88" height="88" viewBox="0 0 88 88">
              <rect [attr.fill]="icons.regXchangeGet.colours.main" width="88" height="88"/>
              <path fill="#231F20" d="M25.66,12.26h14.51l18.28,22.33L25.66,75.61H11.01c11.26-13.63,22.51-27.26,33.77-40.88
	C38.4,27.24,32.03,19.75,25.66,12.26z"/>
              <polygon fill="#FFFFFF" points="62.63,12.26 55.24,21.61 62.63,30.54 76.59,12.26 "/>
              <polygon fill="#FFFFFF" points="62.36,56.5 76.59,56.5 62.36,39.05 55.24,47.77 "/>
            </svg>
          </svg>
        </g>
      </svg>
    </g>
    <g id="jira" [attr.opacity]="icons.jira.colours.opacity">
      <svg x="784" y="2192" overflow="visible">
        <g transform="scale(0.5000000000000001) ">
          <svg x="-200" y="-200" width="400" height="400">
            <svg viewBox="0 0 400 400" height="400" width="400">
              <g>
                <path fill-rule="evenodd" [attr.fill]="icons.jira.colours.main"
                      d="M195 16.875c-15.986 5.28-11.975 28.67 4.915 28.67 15.497-.003 20.13-21.225 6.127-28.069-2.201-1.076-8.556-1.422-11.042-.6M146.6 30.37c-15.692 5.537-12.029 28.774 4.536 28.774 11.431 0 18.391-11.923 12.928-22.144-3.112-5.823-11.128-8.866-17.464-6.63m97.6-.289c-13.948 4.63-14.485 23.555-.802 28.262 14.349 4.937 25.955-12.614 15.736-23.795-3.732-4.083-10.232-6.027-14.934-4.467M116.735 70.554c-1.188.646-2.55 3.663-2.189 4.851.124.406.42 2.343.659 4.303 1.708 14.033 10.342 32.205 23.02 48.45 7.522 9.637 12.65 15.27 32.579 35.786 35.2 36.236 44.562 50.436 47.569 72.15.758 5.474 1.005 5.542 19.627 5.378 18.037-.158 17.816-.074 17.674-6.7-.373-17.33-10.264-40.462-26.119-61.082-4.846-6.304-5.042-5.585 4.052-14.838 30.877-31.415 44.108-50.995 49.541-73.308 3.615-14.85 1.613-17.735-9.548-13.746-6.08 2.173-11.382 3.788-18.2 5.545-3.08.793-6.41 1.838-7.4 2.322-1.961.958-1.817.732-5.539 8.68-2.942 6.281-7.35 13.012-13.618 20.79-4.804 5.963-23.05 25.391-26.398 28.11-3.341 2.711-4.684 1.743-18.998-13.7-16.268-17.552-22.988-26.807-28.24-38.89-1.811-4.168-2.646-4.878-7.221-6.14l-7.386-2.042c-3.668-1.013-13.747-4.23-17.89-5.71-2.669-.954-4.486-1.017-5.975-.209m65.48 13.918c-4.253 1.418-2.581 7.761 4.922 18.672 9.777 14.218 13.098 15.148 20.716 5.802 10.214-12.53 13.986-21.934 9.715-24.219-.987-.528-33.823-.765-35.353-.255m-19.18 99.172c-2.256 2.282-10.435 16.962-12.475 22.393-6.867 18.274-8.729 31.942-4.712 34.576 1.352.886 29.057 1.364 31.824.55 2.177-.642 3.096-2.424 3.781-7.333.862-6.173 2.832-12.378 6.01-18.927 3.65-7.52 2.476-9.96-12.277-25.51-1.696-1.787-3.578-3.84-4.182-4.563-2.395-2.865-5.808-3.372-7.969-1.186M94.181 290.202l-.981 1.06-.006 36.24c-.005 29.081-.114 36.697-.549 38.546-1.001 4.256-4.027 7.41-7.952 8.288-5.801 1.298-5.926 1.72-3.088 10.454 2.327 7.163 2.509 7.322 7.719 6.738 11.386-1.277 20.001-8.63 22.94-19.584.636-2.37.71-6.022.832-41.516l.134-38.916-1.184-1.184-1.184-1.184h-15.7l-.981 1.058m35.945-.655c-1.751.705-1.726.008-1.726 48.11v46.163l.841.762c.878.796 13.423 1.377 16.651.771 2.234-.419 2.148 1.524 2.128-48.119l-.019-46.29-1.023-.9c-1.095-.964-14.698-1.365-16.852-.497m35.6-.02c-1.752.746-1.726.031-1.726 48.13v46.163l.841.762c.978.886 15.196 1.384 17.249.604 1.721-.654 1.905-2.25 1.908-16.493.002-15.634-.727-14.098 6.784-14.286 8.637-.216 8.231-.487 15.472 10.337.663.99 3.34 4.86 5.951 8.6 2.611 3.74 5.413 7.797 6.228 9.016 2.204 3.297 1.525 3.184 19.132 3.184 19.438 0 16.755 1.683 21.037-13.2 1.01-3.512 1.721-5.907 3.797-12.8.431-1.43 1.257-4.22 1.837-6.2.579-1.98 1.376-4.68 1.771-6 .395-1.32 1.205-4.11 1.799-6.2.594-2.09 1.788-6.14 2.654-9 .865-2.86 2.031-6.73 2.591-8.6 1.989-6.645 2.225-7.23 3.159-7.844 1.76-1.152 3.141.338 4.313 4.655 1.286 4.738 5.56 19.56 6.492 22.514 1.709 5.421 1.76 5.373-5.909 5.544-7.337.163-6.86-.257-9.277 8.18-2.781 9.708-3.181 9.351 10.491 9.351 11.354 0 11.5.038 12.438 3.273 5.01 17.273 3.958 16.127 14.792 16.127 11.703 0 11.413.308 8.478-9-.936-2.97-2.064-6.57-2.507-8-.443-1.43-1.227-3.86-1.742-5.4-.515-1.54-1.775-5.5-2.801-8.8-1.025-3.3-3.002-9.6-4.393-14-1.392-4.4-3.369-10.7-4.395-14a1160.359 1160.359 0 0 0-4.935-15.6 821.48 821.48 0 0 1-2.84-9c-4.259-13.864-2.252-12.4-16.991-12.4h-11.811l-1.184 1.1c-.947.88-1.553 2.3-3.032 7.1-3.724 12.088-10.418 33.325-11.789 37.4a203.3 203.3 0 0 0-1.798 5.8c-1.501 5.104-4.565 14.836-5.415 17.2-.396 1.1-1.21 3.62-1.808 5.6-3.57 11.802-3.048 11.677-9.524 2.284-2.534-3.676-5.5-7.963-6.59-9.527-3.118-4.47-3.116-4.485.891-7.163 7.254-4.848 9.16-10.547 9.16-27.394 0-21.145-4.29-28.08-19.324-31.243-4.603-.968-47.446-1.639-49.474-.775m42.811 18.427c5.017 1.55 5.864 3.578 5.861 14.037-.004 13.983-.978 14.754-18.642 14.754-9.011 0-10.588-.089-11.127-.629-1.011-1.01-.944-27.948.071-28.539 1.451-.845 20.875-.537 23.837.377"></path>
              </g>
            </svg>
          </svg>
        </g>
      </svg>
    </g>
    <g id="diffs" [attr.opacity]="icons.diffReport.colours.opacity">
      <svg x="1840" y="1526" overflow="visible">
        <g transform="scale(3.4119689598080285) matrix(0.707, 0.409, 0, 0.816, 0, 0) translate(13.5 0)">
          <circle cx="0" cy="0" [attr.fill]="icons.diffReport.colours.main" r="23"></circle>
          <svg width="27" height="32" x="-13.5" y="-16" [attr.fill]="icons.diffReport.colours.background">
            <svg xmlns="http://www.w3.org/2000/svg" width="27" height="32" viewBox="0 0 27 32">
              <path
                d="M26.214 6.786c.661.661 1.214 1.982 1.214 2.929v20.571c0 .946-.768 1.714-1.714 1.714h-24A1.715 1.715 0 0 1 0 30.286V1.715C0 .769.768.001 1.714.001h16c.946 0 2.268.554 2.929 1.214zm-7.928-4.357v6.714H25c-.107-.304-.268-.607-.393-.732l-5.589-5.589c-.125-.125-.429-.286-.732-.393zm6.857 27.285V11.428h-7.429A1.715 1.715 0 0 1 16 9.714V2.285H2.286v27.429h22.857zm-16.572-16a.571.571 0 0 1 .804-.107l.911.679c.25.196.304.554.107.804l-3.25 4.339 3.25 4.339a.572.572 0 0 1-.107.804l-.911.679a.572.572 0 0 1-.804-.107l-4.036-5.375a.591.591 0 0 1 0-.679zm14.322 5.375a.591.591 0 0 1 0 .679l-4.036 5.375a.571.571 0 0 1-.804.107l-.911-.679a.571.571 0 0 1-.107-.804l3.25-4.339-3.25-4.339a.572.572 0 0 1 .107-.804l.911-.679a.572.572 0 0 1 .804.107zm-11.072 8.232a.567.567 0 0 1-.464-.661l2.464-14.839a.567.567 0 0 1 .661-.464l1.125.179a.567.567 0 0 1 .464.661l-2.464 14.839a.567.567 0 0 1-.661.464z"></path>
            </svg>
          </svg>
        </g>
      </svg>
    </g>
  </g>
  <g id="labels">
    <g id="enrichLabel" [attr.opacity]="labels.enrich.colours.opacity">
      <svg x="912" y="1656" overflow="visible">
        <text
          font-family="Open Sans" y="46.76" font-size="34pt" [attr.fill]="labels.enrich.colours.label" font-weight="bold"
          transform="matrix(0.707 0.409 -0.707 0.409 0 0)" xml:space="preserve"><tspan x="8" dy="0">ENRICH</tspan></text>
      </svg>
    </g>
    <g id="transformLabel" [attr.opacity]="labels.transform.colours.opacity">
        <svg x="720" y="1767" overflow="visible">
          <text
            font-family="Open Sans" y="46.76" font-size="34pt" [attr.fill]="labels.transform.colours.label" font-weight="bold"
            transform="matrix(0.707 0.409 -0.707 0.409 0 0)" xml:space="preserve"><tspan x="8" dy="0">TRANSFORM</tspan></text>
        </svg>
    </g>
    <g id="ingestLabel" [attr.opacity]="labels.ingest.colours.opacity">
        <svg x="528" y="1878" overflow="visible">
          <text
            font-family="Open Sans" y="46.76" font-size="34pt" [attr.fill]="labels.ingest.colours.label" font-weight="bold"
            transform="matrix(0.707 0.409 -0.707 0.409 0 0)" xml:space="preserve"><tspan x="8" dy="0">INGEST</tspan></text>
        </svg>
    </g>
    <g id="combineLabel" [attr.opacity]="labels.combine.colours.opacity">
        <svg x="1104" y="1545" overflow="visible">
          <text
            font-family="Open Sans" y="46.76" font-size="34pt" [attr.fill]="labels.combine.colours.label" font-weight="bold"
            transform="matrix(0.707 0.409 -0.707 0.409 0 0)" xml:space="preserve"><tspan x="8" dy="0">COMBINE</tspan></text>
        </svg>
    </g>
    <g id="validateLabel" [attr.opacity]="labels.validate.colours.opacity">
        <svg x="624" y="1526" overflow="visible">
          <text
            font-family="Open Sans" y="46.76" font-size="34pt" [attr.fill]="labels.validate.colours.label" font-weight="bold"
            transform="matrix(0.707 -0.409 0.707 0.409 0 0)" xml:space="preserve"><tspan x="8" dy="0">VALIDATE</tspan></text>
        </svg>
    </g>
    <g id="encapsulateLabel" [attr.opacity]="labels.encapsulate.colours.opacity">
        <svg x="1296" y="1434" overflow="visible">
          <text
            font-family="Open Sans" y="46.76" font-size="34pt" [attr.fill]="labels.encapsulate.colours.label" font-weight="bold"
            transform="matrix(0.707 0.409 -0.707 0.409 0 0)" xml:space="preserve"><tspan x="8" dy="0">ENCAPSULATE</tspan></text>
        </svg>
    </g>
    <g id="publishLabel" [attr.opacity]="labels.publish.colours.opacity">
        <svg x="1488" y="1323" overflow="visible">
          <text
            font-family="Open Sans" y="46.76" font-size="34pt" [attr.fill]="labels.publish.colours.label" font-weight="bold"
            transform="matrix(0.707 0.409 -0.707 0.409 0 0)" xml:space="preserve"><tspan x="8" dy="0">PUBLISH</tspan></text>
        </svg>
    </g>
    <g id="retrieveLabel" [attr.opacity]="labels.regXchangeGet.colours.opacity">
        <svg x="1472" y="1795" overflow="visible">
          <text
            font-family="Open Sans" y="46.76" font-size="34pt" [attr.fill]="labels.regXchangeGet.colours.label" font-weight="bold"
            transform="matrix(0.707 -0.409 0.707 0.409 0 0)" xml:space="preserve"><tspan x="8" dy="0">RETRIEVE</tspan></text>
        </svg>
    </g>
    <g id="diffsLabel" [attr.opacity]="labels.diffReport.colours.opacity">
        <svg x="1744" y="1563" overflow="visible">
          <text
            font-family="Open Sans" y="59.3" font-size="45pt" [attr.fill]="labels.diffReport.colours.label" font-weight="bold"
            transform="matrix(0.707, 0.409, 0, 0.816, 0, 0)" xml:space="preserve"><tspan x="8" dy="0">DIFFS</tspan></text>
        </svg>
    </g>
  </g>
</svg>
